import { staticMediaUrl } from '@/fo/util/image-loader';

export const importantProjectsMock = {
  type: 'image' as const,
  itemsTitle: 'Наши проекты',
  autoplay: true,
  items: [
    {
      id: 0,
      title: '#ЛечимАкнеВместе',
      image: staticMediaUrl('section/important-project/img-1.png'),
      colorTitle: '#00C389',
      text: 'Проект об уходе за проблемной кожей',
      link: 'https://acneproject.naos.ru/',
      linkText: '#ЛечимАкнеВместе',
      linkColor: '#000000',
      iconColor: '#00C389',
      showLinkButton: true,
      isBlank: true
    },
    {
      id: 1,
      title: '#УАтопииЕстьЛицо',
      image: staticMediaUrl('section/important-project/img-2.png'),
      colorTitle: '#0077CF',
      text: 'Сообщество и канал об атопическом дерматите ВКонтакте',
      link: 'https://vk.ru/atopyhasaface',
      linkText: '#УАтопииЕстьЛицо',
      iconColor: '#0077CF',
      showLinkButton: true,
      isBlank: true
    }
  ]
};
